// @flow
import type {Element} from 'react'
import React from 'react'
import ReactDatePicker from 'react-datepicker'

import convertPosixToLdml from 'utils/MiscUtils/convertPosixToLdml'
import styles from './index.scss'

type Props = {|
  className?: ?string,
  disabled?: ?boolean,
  id?: ?string,
  minDate?: ?Date,
  onChange?: ?Date => void,
  selected?: ?Date,
  placeholderAppend?: ?string,
|}

function DatePicker({
  className = null,
  disabled = false,
  id = null,
  minDate = null,
  onChange = () => {},
  selected = null,
  placeholderAppend = '',
}: Props): Element<"div"> {
  const dateFormat = convertPosixToLdml(I18n.t('date.formats.default'))
  const placeholderText = placeholderAppend
    ? `${dateFormat.toUpperCase()} ${placeholderAppend || ''}` : dateFormat.toUpperCase()

  return (
    <div className={styles.datePicker}>
      <ReactDatePicker
        className={className}
        disabled={disabled}
        id={id}
        minDate={minDate}
        onChange={onChange}
        selected={selected}
        dateFormat={dateFormat}
        placeholderText={placeholderText}
      />
    </div>
  )
}

export default DatePicker
